import React from 'react';
import { Router, Route, Switch, Redirect } from 'dva/router';
import dynamic from 'dva/dynamic';
import route_map from '../config/route_map';

function RouterConfig({ history, app }) {
  // 首页
  const IndexRC = dynamic({
    app,
    models: () => [import('../models/index')],
    component: () => import('../views/Home/Home'),
  });
  const NewIndexRC = dynamic({
    app,
    models: () => [import('../models/index')],
    component: () => import('../views/NewHome/NewHome'),
  });
  // login 登录
  const LoginRC = dynamic({
    app,
    models: () => [import('../models/user')],
    component: () => import('../views/Sign/SignIn'),
  });
  // register 注册
  const RegisterRC = dynamic({
    app,
    models: () => [import('../models/user')],
    component: () => import('../views/Sign/SignUp'),
  });
  // stableFAQ
  const StableFaqRC = dynamic({
    app,
    component: () => import('../views/Stable/Faq'),
  });
  // stableInfo
  const StableInfoRC = dynamic({
    app,
    component: () => import('../views/Stable/Info'),
  });
  // 404
  const NotFountRC = dynamic({
    app,
    component: () => import('../views/404'),
  });
  // 提交快速买卖
  const SubmitData = dynamic({
    app,
    component: () => import('../views/trade/index'),
  });
  // 合约新手引导
  const FutureGuestRC = dynamic({
    app,
    models: () => [import('../models/future')],
    component: () => import('../views/future/guest'),
  });
  // 周年庆
  const AnniversaryRC = dynamic({
    app,
    models: () => [import('../models/anniversary')],
    component: () => import('../views/Anniversary'),
  });
  // 理财
  const EarnFaqRC = dynamic({
    app,
    component: () => import('../views/Earn/faq'),
  });

  // 活动
  const RewardCenterFC = dynamic({
    app,
    component: () => import('../views/RewardCenter/RewardCenter'),
  });

  // 合约大赛
  const ContractContestFC = dynamic({
    app,
    component: () => import('../views/ContractContest/ContractContest'),
  });

  // 世界杯
  const WorldCupFC = dynamic({
    app,
    component: () => import('../views/WorldCup'),
  });

  const AppTest = dynamic({
    app,
    component: () => import('../views/_test/appTest'),
  });

  return (
    <Router history={history}>
      <Switch>
        {/* 首页 */}
        {/* <Route exact path={route_map.index} component={IndexRC} /> */}
        <Route exact path={route_map.index} component={NewIndexRC} />
        <Redirect exact path="/" to={route_map.index} />
        {/* 登录 */}
        <Route exact path={route_map.login} component={LoginRC} />
        {/* 邀请码注册 */}
        <Route exact path={route_map.register + '/:invite_code'} component={RegisterRC} />
        {/* 注册 */}
        <Route exact path={route_map.register} component={RegisterRC} />
        {/* FAQ */}
        {/* <Route exact path={route_map.stableFaq} component={StableFaqRC} /> */}
        {/* <Route exact path={route_map.stableInfo} component={StableInfoRC} /> */}
        <Route exact path={route_map.earnFaq} component={EarnFaqRC} />
        {/* 合约新手引导 */}
        {/* <Route exact path={route_map.future_guest} component={FutureGuestRC} /> */}
        {/* 提交快速买卖 */}
        {/* <Route exact path={route_map.submit_data} component={SubmitData} /> */}
        {/* 周年庆活动 */}
        <Route exact path={route_map.anniversary} component={AnniversaryRC} />
        {/* 活动 */}
        <Route exact path={route_map.rewardCenter} component={RewardCenterFC} />
        {/* 合约大赛 */}
        <Route exact path={route_map.contractContest} component={ContractContestFC} />
        {/* 世界杯 */}
        <Route exact path={route_map.worldCup} component={WorldCupFC} />
        {/* 客户端 JSBridge 的测试页面 */}
        <Route exact path={route_map.appTest} component={AppTest} />
        <Route component={NotFountRC} />
      </Switch>
    </Router>
  );
}

export default RouterConfig;
